<template>
  <div class="order-detail">
    <div class="order-bar public">
      <div class="order-bar__name">
        {{ orderDetail.productName }}
      </div>
      <div
        class="order-bar__status"
        :class="{active: [CarLifeOrderStatus.unpaid, CarLifeOrderStatus.processing].includes(orderDetail.rechargeStatus)}"
      >
        {{ orderDetail.rechargeStatus | statusFilter }}
      </div>
    </div>
    <div class="base-info public">
      <div class="base-info__column">
        <div class="field">充值方式</div>
        <div class="value">{{ orderDetail.rechargeWay | rechargeTypeFilter }}</div>
      </div>
      <!-- 非账号直充 -->
      <template v-if="orderDetail.rechargeWay !== RechargeType.account">
        <div class="base-info__column">
          <div class="field">接收账号</div>
          <div class="value">{{ orderDetail.rechargeAccount }}</div>
        </div>
        <div class="base-info__column">
          <div class="field">数量</div>
          <div class="value">{{ orderDetail.cardQuantity }}</div>
        </div>
      </template>
      <template v-else>
        <div class="base-info__column">
          <div class="field">充值账号</div>
          <div class="value">{{ orderDetail.rechargeAccount }}</div>
        </div>
      </template>
      <div class="base-info__column">
        <div class="field">商品售价</div>
        <div class="value">¥ {{ orderDetail.productSkuPrice | yuan }}</div>
      </div>
      <div class="base-info__column">
        <div class="field">权益优惠</div>
        <div class="value">¥ {{ orderDetail.rightDiscount | yuan }}</div>
      </div>
      <div class="base-info__column">
        <div class="field">支付金额</div>
        <div class="value">¥ {{ orderDetail.customerPay | yuan }}</div>
      </div>
    </div>
    <div class="line public">
      <div class="line-content" />
    </div>
    <div class="order-info public">
      <div class="order-info__column">
        <div class="field">订单编号：</div>
        <div class="value">{{ orderDetail.orderNo }}</div>
      </div>
      <div class="order-info__column">
        <div class="field">支付时间：</div>
        <div class="value">{{ orderDetail.paidTime }}</div>
      </div>
    </div>

    <!-- 卡密充值展示  -->
    <template
      v-if="orderDetail.rechargeWay === RechargeType.recharge && orderDetail.cardDTOs && orderDetail.cardDTOs.length !== 0"
    >
      <div class="line public">
        <div class="line-content" />
      </div>
      <div
        class="card-info public"
      >
        <div class="card-info__header">
          <div class="title">提取卡密</div>
          <div
            class="btn"
            @click="copyAll"
          >复制全部</div>
        </div>
        <template v-for="(item, idx) in orderDetail.cardDTOs">
          <div
            class="card-info__item"
            :key="item.cardNo"
          >
            <div class="item-field">
              卡号{{ idx + 1 }}：{{ item.cardNo }}
              <img
                class="icon"
                :src="icon_copy"
                @click="copy($event, item, idx, 1)"
              >
            </div>
            <div class="item-field">
              密码{{ idx + 1 }}：
              <template v-if="item.hidden">
                <span>{{ item.cardPwd }}</span>
                <img
                  class="icon"
                  :src="icon_hidden"
                  @click="toggleShow(item, false)"
                >
              </template>
              <template v-if="!item.hidden">
                <span>{{ item.cardPwdShow }}</span>
                <img
                  class="icon"
                  :src="icon_show"
                  @click="toggleShow(item, true)"
                >
              </template>
              <img
                class="icon"
                :src="icon_copy"
                @click="copy($event, item, idx, 2)"
              >
            </div>
            <div class="item-bottom">
              有效期截止：{{ item.expireTime }}
            </div>
          </div>
        </template>
      </div>
    </template>

    <div
      class="pay-button public"
      v-if="CarLifeOrderStatus.unpaid === orderDetail.rechargeStatus"
    >
      <div
        class="btn pay"
        @click="submitClick"
      >立即支付</div>
      <div
        class="btn cancel"
        @click="preCancel"
      >取消订单</div>
    </div>

    <template v-if="orderDetail.refundStatus !== null || orderDetail.rechargeStatus === CarLifeOrderStatus.cancel">
      <div class="line public">
        <div class="line-content" />
      </div>
      <div class="pay-info public">
        <div class="pay-info__column">
          <div class="field">退款总额：</div>
          <div class="value">¥ {{ orderDetail.refundTotalAmount | yuan }}</div>
        </div>
        <div class="pay-info__column">
          <div class="field">权益金额：</div>
          <div class="value">¥ {{ orderDetail.rightDiscount | yuan }}</div>
        </div>
        <div class="pay-info__column">
          <div class="field">在线支付：</div>
          <div class="value">¥ {{ orderDetail.refundAmount | yuan }}</div>
        </div>
      </div>
      <div
        class="pay-tips public"
        v-if="orderDetail.refundStatus == 1"
      >
        支付金额将在1-3个工作日内退回原支付账户
      </div>
    </template>

    <van-popup
      class="confirm-dialog"
      v-model="cancelDialogShow"
      round
    >
      <div class="confirm-dialog__header">
        <div class="title">确认取消订单</div>
      </div>
      <div class="confirm-dialog__body">
        <a
          href="tel:4000026862"
          style="color: #3399ff"
        >联系客服</a>
      </div>
      <div class="confirm-dialog__footer">
        <div
          class="btn"
          @click="cancelDialogShow = false"
        >再考虑一下</div>
        <div
          class="btn confirm"
          @click="cancelConfirm"
        >坚持取消</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import icon_copy from '@/assets/img/car-life/icon_copy@2x.png';
import icon_show from '@/assets/img/car-life/icon_show@2x.png';
import icon_hidden from '@/assets/img/car-life/icon_hidden@2x.png';
import { carLifeOrderCancel, carLifeOrderDetail, carLifePayPre, getCardInfo } from '@/common/api';
import { CarLifeOrderStatus, RechargeType } from '@/common/constant';
import { debounce } from 'lodash';
import { handleClipboard } from '@/common/clipboard';
import Pay from '@/common/weixin';
import { cookieSet } from '@/common/cookie';

export default {
  name: 'OrderDetail',
  data() {
    return {
      icon_copy,
      icon_show,
      icon_hidden,
      cancelDialogShow: false,
      CarLifeOrderStatus,
      RechargeType,
      orderDetail: {}
    };
  },
  components: {},
  filters: {
    yuan(val) {
      if (!val) {
        return '0.00';
      }
      return Number(val).toFixed(2);
    },
    statusFilter(value) {
      if (!value) {
        return '';
      }
      const statusMap = {
        [CarLifeOrderStatus.unpaid]: '待支付',
        [CarLifeOrderStatus.success]: '已完成',
        [CarLifeOrderStatus.cancel]: '已取消',
        [CarLifeOrderStatus.processing]: '处理中'
      };
      return statusMap[value];
    },
    rechargeTypeFilter(value) {
      if (!value) {
        return '';
      }
      const typeMap = {
        [RechargeType.account]: '账号直充',
        [RechargeType.recharge]: '卡密兑换',
        [RechargeType.coupon]: '券码兑换'
      };
      return typeMap[value];
    }
  },
  computed: {
    // 支付后的订单
    isRefunded() {
      return this.orderDetail.refundAmount && this.orderDetail.refundAmount > 0;
    }
  },
  methods: {
    async getDetail() {
      const data = await carLifeOrderDetail({
        orderNo: this.orderNo
      });
      const result = data || {};
      if (result.cardDTOs && result.cardDTOs.length) {
        result.cardDTOs.forEach(item => {
          item.hidden = true;
          // 设置真实卡密内存
          item.cardPwdShow = '';
        });
      }
      this.orderDetail = result;
    },
    toggleShow: debounce(async function(item, val) {
      item.hidden = val;
      if (item.cardPwdShow === '') {
        // 获取真实卡密接口
        const res = await getCardInfo({
          cardIds: [item.id]
        });
        if (res && res.length) {
          item.cardPwdShow = res[0].cardPwd;
        }
      }
    }, 200),
    async copy(e, item, index, type) {
      let content = '';
      if (type === 1) {
        content = `卡号${index + 1}：${item.cardNo}`;
      } else if (type === 2) {
        content = `卡密${index + 1}：`;
        if (item.cardPwdShow === '') {
          // 获取真实卡密接口
          const res = await getCardInfo({
            cardIds: [item.id]
          });
          if (res && res.length) {
            item.cardPwdShow = res[0].cardPwd;
          }
        }
        content += item.cardPwdShow;
      }

      handleClipboard(content, e);
    },
    copyAll: debounce(async function(e) {
      const cardIds = this.orderDetail.cardDTOs.map(item => item.id);
      // 获取真实卡密接口
      const res = await getCardInfo({ cardIds });
      if (res && res.length) {
        this.orderDetail.cardDTOs.forEach(card => {
          const findCard = res.find(item => item.id === card.id);
          if (findCard) {
            card.cardPwdShow = findCard.cardPwd;
          }
        });
      }

      let content = '';
      this.orderDetail.cardDTOs.forEach((card, idx) => {
        content += `卡号${idx + 1}：${card.cardNo}\n`;
        content += `卡密${idx + 1}：${card.cardPwdShow}\n`;
      });
      handleClipboard(content, e);
    }, 200),
    preCancel() {
      this.cancelDialogShow = true;
    },
    cancelConfirm: debounce(async function() {
      await carLifeOrderCancel({
        orderNo: this.orderDetail.orderNo
      });
      this.cancelDialogShow = false;
      this.$toast('取消成功');
      this.getDetail();
    }, 200),

    submitClick() {
      this.pay(this.orderNo);
    },
    // ---------- 下单流程 start -------------
    async pay(orderNo) {
      const envMap = ['1', '1', '4'];
      // 调起预支付接口成功后
      const prepayRs = await carLifePayPre({
        payType: envMap[this.$browserEnv], // 支付环境
        orderNo
      });
      this.prePayHandle(prepayRs);
    },

    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayFail);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },

    prePaySuccess(orderNo) {
      this.$router.push({
        name: 'resultPage',
        query: {
          orderNo: orderNo,
          orderStatus: CarLifeOrderStatus.success,
          orderType: '02'
        }
      });
    }
    // ---------- 下单流程 end ---------------
  },
  created() {
    // 处理从小程序入口跳转过来
    if (this.$route.query.token) {
      let token = this.$route.query.token;
      token = (token || '').replace(/\s/g, '+');
      token && cookieSet('token', token);
    }
    this.orderNo = this.$route.query.orderNo;
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.order-detail {
  background-color: #F2F5F7;
  overflow: hidden;

  .public {
    padding: 0 .4rem;
    background-color: white;
  }

  .line {
    &-content {
      height: 1px;
      background-color: #E6E6E6;
    }
  }

  .order-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: .98rem;
    margin-top: .25rem;
    box-shadow: inset 0px -1px 0px 0px rgba(230, 230, 230, 1);

    &__name {
      font-size: .32rem;
      color: #383838;
    }

    &__status {
      font-size: .32rem;

      &.active {
        color: #3399FF;
      }
    }
  }

  .base-info {
    padding: .4rem;
    overflow: hidden;

    &__column {
      display: flex;
      justify-content: space-between;
      line-height: .45rem;
      align-items: center;
      font-size: .32rem;
      margin-bottom: .24rem;

      &:last-child {
        margin-bottom: 0;
      }

      > .field {
        color: #787878;
      }

      > .value {
        color: #383838;
      }
    }
  }

  .order-info {
    padding: .4rem;
    overflow: hidden;

    &__column {
      display: flex;
      line-height: .45rem;
      align-items: center;
      font-size: .32rem;
      margin-bottom: .24rem;

      &:last-child {
        margin-bottom: 0;
      }

      > .field {
        color: #787878;
      }

      > .value {
        color: #383838;
      }
    }
  }

  .card-info {
    padding: .4rem;

    &__header {
      display: flex;
      align-items: flex-end;

      > .title {
        font-size: .32rem;
        color: #383838;
      }

      > .btn {
        font-size: .24rem;
        color: #3399FF;
        margin-left: .32rem;
      }
    }

    &__item {
      background: #F2F5F7;
      border-radius: 8px;
      margin: .23rem 0;
      padding: .15rem .25rem;

      &:last-child {
        margin-bottom: 0;
      }

      > .item-field {
        display: flex;
        align-items: center;
        font-size: .24rem;
        line-height: .33rem;
        color: #4D4D4D;
        margin-bottom: .16rem;

        > .icon {
          width: .24rem;
          height: .24rem;
          margin-left: .24rem;
        }
      }

      > .item-bottom {
        font-size: .2rem;
        color: #999999;
      }
    }
  }

  .pay-button {
    overflow: hidden;

    > .btn {
      height: .96rem;
      line-height: .96rem;
      text-align: center;
      font-size: .36rem;
      margin: 0 .4rem;
      border-radius: .16rem;
      margin-bottom: .16rem;

      &.pay {
        color: #FFFFFF;
        background: #3399FF;
      }

      &.cancel {
        font-size: .32rem;
        color: #5986B3;
      }
    }
  }

  .pay-info {
    padding: .4rem;
    overflow: hidden;

    &__column {
      display: flex;
      justify-content: space-between;
      line-height: .45rem;
      align-items: center;
      font-size: .32rem;
      margin-bottom: .24rem;

      &:last-child {
        margin-bottom: 0;
      }

      > .field {
        color: #787878;
      }

      > .value {
        color: #383838;
      }
    }
  }

  .pay-tips {
    font-size: .28rem;
    color: #EA3F26;
  }

  .confirm-dialog {
    width: 6rem;

    &__header {
      display: flex;
      font-size: 0.32rem;
      height: .98rem;
      justify-content: center;
      align-items: center;

      .title {
        font-weight: 400;
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      margin: .32rem .46rem;
      font-size: .28rem;
      color: #3399FF;
      text-align: center;
    }

    &__footer {
      display: flex;
      height: .97rem;
      line-height: .97rem;
      border-top: .02rem solid #E6E6E6;

      > .btn {
        flex: 1;
        text-align: center;
        font-size: .32rem;
        color: #383838;

        &:first-child {
          border-right: .02rem solid #E6E6E6;
        }

        &.confirm {
          color: #EA3F26;
        }
      }
    }
  }

}
</style>
